import OurTeam from '../sections/our-team/OurTeam';
import App from '../App';

window.App = App;
window.Section = OurTeam;


